import { useEffect, useState } from 'react';

import { FOutlinedValue } from '../../../../../../../components/baseV2';
import { formatDurationTime } from '../utils';

import type { DurationStopwatchProps } from '../types';

function DurationStopwatch({ startTimer, timerLimit, onStop }: DurationStopwatchProps) {
  const [elapsedTime, setElapsedTime] = useState(0);

  useEffect(() => {
    if (!startTimer) {
      return undefined;
    }

    const intervalId = window.setInterval(() => {
      setElapsedTime((prev) => prev + 1);
    }, 1000);

    return () => window.clearInterval(intervalId);
  }, [startTimer]);

  useEffect(() => {
    if (!startTimer && elapsedTime > 0) {
      onStop(elapsedTime);
      setElapsedTime(0);
    }
  }, [elapsedTime, onStop, startTimer]);

  useEffect(() => {
    if (elapsedTime > timerLimit - 1) {
      if (elapsedTime > 0) {
        onStop(elapsedTime);
        setElapsedTime(0);
      }
    }
  }, [elapsedTime, onStop, timerLimit]);

  return <FOutlinedValue label="Current timer" value={formatDurationTime(elapsedTime)} />;
}

export default DurationStopwatch;
